import React, { useState } from "react";
import { resetPassword } from "../logic/loginLogic";
import "./ForgotPasswordModal.css";

const ForgotPasswordModal = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [emailSent, setEmailSent] = useState(false);

  const handleReset = async () => {
    const result = await resetPassword(email);
    if (result.success) {
      setStatus("✅ E-mail de réinitialisation envoyé ! Vérifiez vos spams");
      setEmailSent(true);
    } else {
      setStatus("❌ " + result.message);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal forgot-modal">
        <h3>Reset Password</h3>
        <label className="reset-label-text">Entrez votre email</label>
        <input
          type="email"
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <div className="modal-button-row">
          <button onClick={handleReset} disabled={emailSent}>
            {emailSent ? "✅ Check your email" : "Reset"}
          </button>
          <button onClick={onClose}>Cancel</button>
        </div>
        {status && <p>{status}</p>}
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
